export default "__VITE_ASSET__obQHS8TF__"